/**
 * smarte Swiper — shared carousel init for theme sections.
 * Automatically aligns to .page-width--slider with matching start & end offsets.
 */
(function () {
  const INSTANCES = new WeakMap();

  function getPageInset(element) {
    const section = element?.closest('section');
    const pageWidth =
      section?.querySelector('.page-width--slider') ||
      // section?.querySelector('.page-width') ||
      document.querySelector('.page-width--slider');

    if (!pageWidth) return 16;

    const rect = pageWidth.getBoundingClientRect();
    const computed = window.getComputedStyle(pageWidth);
    const paddingLeft = Number.parseFloat(computed.paddingLeft) || 0;

    const totalInset = rect.left + paddingLeft;
    return Math.max(Math.round(totalInset), 16);
  }

  function parseBoolean(value, defaultValue) {
    if (value == null || value === '') return defaultValue;
    return value !== 'false';
  }

  function parseNumber(value, defaultValue) {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : defaultValue;
  }

  function getSlidesTrackWidth(swiper) {
    const spaceBetween = swiper.params.spaceBetween || 0;
    let totalWidth = 0;

    swiper.slides.forEach((slide, index) => {
      totalWidth += slide.offsetWidth;
      if (index < swiper.slides.length - 1) {
        totalWidth += spaceBetween;
      }
    });

    return totalWidth;
  }

  function updateCenterOffsets(swiper) {
    if (swiper.el.dataset.align !== 'center') return;

    const totalWidth = getSlidesTrackWidth(swiper);
    const containerWidth = swiper.width;
    const edgePadding = parseNumber(swiper.el.dataset.edgePadding, 24);

    if (totalWidth <= containerWidth) {
      const offset = Math.max(Math.round((containerWidth - totalWidth) / 2), 0);
      swiper.params.slidesOffsetBefore = offset;
      swiper.params.slidesOffsetAfter = offset;
    } else {
      swiper.params.slidesOffsetBefore = edgePadding;
      swiper.params.slidesOffsetAfter = edgePadding;
    }

    swiper.update();
  }

  function updateStartOffsets(swiper) {
    if (swiper.el.dataset.align !== 'start') return;

    const edgePadding = parseNumber(swiper.el.dataset.edgePadding, 16);
    const usePageInset = swiper.el.dataset.pageInset === 'true';
    const offset = usePageInset ? getPageInset(swiper.el) : edgePadding;

    swiper.params.slidesOffsetBefore = offset;
    swiper.params.slidesOffsetAfter = offset;
    swiper.update();
  }

  function buildConfig(element) {
    const align = element.dataset.align || 'center';
    const spaceBetween = parseNumber(element.dataset.spaceBetween, 0);
    const freeMode = parseBoolean(element.dataset.freeMode, true);
    const navPrev = element.dataset.navPrev;
    const navNext = element.dataset.navNext;

    const config = {
      slidesPerView: 'auto',
      spaceBetween,
      freeMode: freeMode ? { enabled: true } : false,
      grabCursor: true,
      watchOverflow: true,
      centerInsufficientSlides: align === 'center', // Native Swiper centering
      resistanceRatio: 0.85,
      slideToClickedSlide: false,
      watchSlidesProgress: true,
    };

    if (navPrev && navNext) {
      config.navigation = {
        prevEl: navPrev,
        nextEl: navNext,
      };
    }

    if (align === 'start') {
      config.on = {
        init() {
          updateStartOffsets(this);
        },
        resize() {
          updateStartOffsets(this);
        },
      };
    }

    return config;
  }

  function initSwiper(element) {
    if (element.dataset.smarteSwiperInitialized === 'true') return;

    if (typeof Swiper === 'undefined') {
      window.setTimeout(() => initSwiper(element), 50);
      return;
    }

    element.dataset.smarteSwiperInitialized = 'true';
    const instance = new Swiper(element, buildConfig(element));
    INSTANCES.set(element, instance);
  }

  function destroySwiper(element) {
    const instance = INSTANCES.get(element);
    if (!instance) return;

    instance.destroy(true, true);
    INSTANCES.delete(element);
    delete element.dataset.smarteSwiperInitialized;
  }

  function initSwipers(root = document) {
    root.querySelectorAll('[data-smarte-swiper]').forEach(initSwiper);
  }

  function destroySwipers(root = document) {
    root.querySelectorAll('[data-smarte-swiper]').forEach(destroySwiper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSwipers());
  } else {
    initSwipers();
  }

  document.addEventListener('shopify:section:load', (event) => initSwipers(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroySwipers(event.target));
})();